import { useQuery } from '@tanstack/react-query'
import { fetchSiteOptions } from '../api/siteOptions'

// Shape matches the REST API response from farafeero/v1/site-options
const FALLBACK_SITE_OPTIONS = {
  contact: {
    phone:         '07775000',
    whatsapp:      '07775000',
    email:         'info@farafeero.com',
    location:      'Cairo, Egypt',
    working_hours: 'Daily: 9 AM – 10 PM',
  },
  hero: {
    title:    'Make Every Birthday Magical!',
    subtitle: "Cairo's #1 children's birthday party planners. Balloons, characters, DJ, photography, and more.",
    image:    null,
  },
  social: {
    facebook:  'https://www.facebook.com/farafeero',
    instagram: 'https://www.instagram.com/farafeero',
    tiktok:    'https://www.tiktok.com/@farafeero',
  },
}

/**
 * Normalize WP REST response to a consistent nested shape.
 * Handles both the nested format the REST API returns and flat ACF fallbacks.
 */
function normalizeSiteOptions(raw) {
  if ( !raw ) return FALLBACK_SITE_OPTIONS

  // Already in nested format { contact, hero, social }
  if ( raw.contact ) return raw

  // Flat ACF format — remap to nested
  return {
    contact: {
      phone:         raw.site_phone         || raw.phone         || FALLBACK_SITE_OPTIONS.contact.phone,
      whatsapp:      raw.site_whatsapp      || raw.whatsapp      || FALLBACK_SITE_OPTIONS.contact.whatsapp,
      email:         raw.site_email         || raw.email         || FALLBACK_SITE_OPTIONS.contact.email,
      location:      raw.site_location      || raw.location      || FALLBACK_SITE_OPTIONS.contact.location,
      working_hours: raw.site_working_hours || raw.working_hours || FALLBACK_SITE_OPTIONS.contact.working_hours,
    },
    hero: {
      title:    raw.hero_title    || raw.title    || FALLBACK_SITE_OPTIONS.hero.title,
      subtitle: raw.hero_subtitle || raw.subtitle || FALLBACK_SITE_OPTIONS.hero.subtitle,
      image:    raw.hero_image    || null,
    },
    social: {
      facebook:  raw.social_facebook  || raw.facebook  || FALLBACK_SITE_OPTIONS.social.facebook,
      instagram: raw.social_instagram || raw.instagram || FALLBACK_SITE_OPTIONS.social.instagram,
      tiktok:    raw.social_tiktok    || raw.tiktok    || FALLBACK_SITE_OPTIONS.social.tiktok,
    },
  }
}

export function useSiteOptions() {
  const query = useQuery({
    queryKey: ['site-options'],
    queryFn: fetchSiteOptions,
    staleTime: 30 * 60 * 1000,
    retry: 1,
    placeholderData: FALLBACK_SITE_OPTIONS,
    select: normalizeSiteOptions,
  })

  return {
    ...query,
    data: query.data ?? FALLBACK_SITE_OPTIONS,
  }
}

export { FALLBACK_SITE_OPTIONS }
